.root {
  position: fixed;
  z-index: 2222;
}

.backdrop {
  z-index: 9999;
}
